export const SET_PREVIOUS_PAGE = 'SET_PREVIOUS_PAGE'
export function setPreviousPage(path) {
    return {
        type: SET_PREVIOUS_PAGE,
        payload: path,
    }
}



// WEBPACK FOOTER //
// ./src/actions/history.js